/**
 * Swym SDK hook: store pending `_swat` and publish `ds:swat-ready` for theme bridge/count.
 */
(() => {
  if (window.__dsSwymUnlockLoaded) {
    return;
  }

  window.__dsSwymUnlockLoaded = true;

  /**
   * @param {object} [swat]
   */
  function publishSwymReady(swat) {
    const resolved = swat || window.__dsSwymPendingSwat || window._swat;

    if (!resolved || typeof resolved.fetch !== 'function') {
      return;
    }

    window.__dsSwymReadySwat = resolved;

    try {
      document.dispatchEvent(
        new CustomEvent('ds:swat-ready', { detail: { swat: resolved } })
      );
    } catch {
      /* CustomEvent unsupported */
    }
  }

  /**
   * @param {object} swat
   */
  function storePendingSwat(swat) {
    if (!swat || typeof swat.fetch !== 'function') {
      return;
    }

    window.__dsSwymPendingSwat = swat;
    publishSwymReady(swat);
  }

  window.dsSwymWishlistStorePending = storePendingSwat;
  window.dsSwymWishlistPublishReady = publishSwymReady;

  window.dsSwymWishlistIsOperational = () => {
    const swat = window.__dsSwymReadySwat || window.__dsSwymPendingSwat || window._swat;

    return Boolean(swat && typeof swat.fetch === 'function');
  };
})();
